import StyledEyebrow, { StyledEyebrowLight } from './styles';

import type { IEyebrowProps } from './types';

const Eyebrow = ({ content, tag = 'div', textColor = '', ...props }: IEyebrowProps) => (
  textColor === 'white' ?
    <StyledEyebrowLight as={tag} {...props}>{content}</StyledEyebrowLight> :
    <StyledEyebrow as={tag} {...props}>{content}</StyledEyebrow>
);

export default Eyebrow;
